import { MemoryItem } from "/components/blocks/layout/types/sidebar-conversation";
import { clients } from 'lib/https';
import { ConfigurationSettings } from "/models/configuration-settings";

export const getMemories = async (
    config: ConfigurationSettings
): Promise<MemoryItem> => {
    const baseUrl = `https://${config.paths.taskforceBaseUrl}`;
    const url = `${baseUrl}${config.paths.taskforce.updateReferenceChatHistoryStatus}`;

   
    return clients.get(url, config.blocksKey);
};


export const deleteMemory = async (
    config: ConfigurationSettings,
    memoryId: string
): Promise<void> => {
    const baseUrl = `https://${config.paths.taskforceBaseUrl}`;
    const url = `${baseUrl}${config.paths.taskforce.updateReferenceChatHistoryStatus}/${memoryId}`;

   
    return clients.delete(url, config.blocksKey);
};
